import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const EditContestPage = ({ contestId, onClose, onSubmit }) => {
  const [ContestData, setEventData] = useState({
    contest_title: '',
    contest_description: '',
    contest_last_date_to_apply: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchEventData = async () => {
      try {
        const response = await axios.get(`/contests/read/${contestId}`);
        const data = response.data;

        // Convert contest_last_date_to_apply to YYYY-MM-DD format
        const formattedDate = new Date(data.contest_last_date_to_apply).toISOString().split('T')[0];

        // Update state with the formatted date
        setEventData({
          contest_title: data.contest_title,
          contest_description: data.contest_description,
          contest_last_date_to_apply: formattedDate,  // Set the formatted date here
        });
      } catch (err) {
        setError('Failed to fetch event data');
      }
    };

    fetchEventData();
  }, [contestId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEventData({ ...ContestData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // PUT request to update event by contestId
      const response = await axios.put(`/contests/edit/${contestId}`, ContestData);
      console.log('Contest updated:', response.data);

      Swal.fire({
        icon: 'success',
        title: 'Contest Updated',
        text: 'The event has been updated successfully!',
        confirmButtonText: 'Okay',
      });

      onSubmit(); // Refresh event list after successful edit
      onClose(); // Close the Edit Contest popup
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update event');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-lg shadow-lg">
        <h2 className="text-lg font-bold mb-4">Edit Contest</h2>
        {/* {error && <p className="text-red-500">{error}</p>} */}
        <form onSubmit={handleSubmit}>
        <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Title</label>
            <input
              type="text"
              name="contest_title"
              value={ContestData.contest_title}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg"
              required
            />
          </div>

          {/* Category Dropdown */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
            <input
              type="text"
              name="contest_description"
              value={ContestData.contest_description}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Last Date To Apply</label>
            <input
              type="date"
              name="contest_last_date_to_apply"
              value={ContestData.contest_last_date_to_apply}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg"
              required
            />
          </div>


          {/* Action buttons */}
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-300 text-black rounded-lg"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded-lg"
              disabled={loading}
            >
              {loading ? 'Updating...' : 'Update Contest'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditContestPage;
